module.exports = __webpack_public_path__ + "static/media/kwara-state-Gov4.6fce22ef.png";